<ng-container *transloco="let t">
  <form [formGroup]="inputForm">
    <div>
      <!-- General data card-->
      <app-admin-card-with-title
        [cardTitle]="t('event.item.generalData')" [showToggleButton]="false" [removeTopMargin]="true">
        <div class="row">
          <div class="col-12 col-xl-6 pe-3 pe-md-4">
            <div class="col-xl pb-3">
              @if (authenticationService.isAdminstrator()) {
                <app-select formControlName="organiserId"
                            [items]="organisers" [valueKey]="'id'" [labelKey]="'name'"
                            label="app.common.organizer"/>
              }
            </div>
            <div class="row pb-3">
              <div class="col-xl-6">
                <!-- Default language dropdown -->
                <app-select formControlName="defaultLanguage"
                            [items]="languages" [valueKey]="'id'" [labelKey]="'code'"
                            [labelKeyPrefix]="'app.common.language.'" label="event.item.defaultLanguage"/>
              </div>
              <!-- Additional lang-->
              <div class="col-xl-6">
                <app-multiselect-dropdown [options]="getOptions()" [formControlName]="'extraLanguages'"
                                          [dropdownLabel]="t('event.item.extraLanguage')"/>
              </div>
            </div>
            <div class="pb-3">
              <app-language-input [inputForm]="inputForm"
                                  [defaultLanguage]="inputForm.controls['defaultLanguage'].value"
                                  [extraLanguages]="inputForm.controls['extraLanguages'].value" [hrKey]="'name'"
                                  [enKey]="'nameEng'"
                                  [srKey]="'nameSr'"
                                  [bsKey]="'nameBs'"
                                  [itKey]="'nameIta'" [siKey]="'nameSlo'" [hrLabel]="'event.item.nameCro'"
                                  [enLabel]="'event.item.nameEn'" [bsLabel]="'event.item.nameBs'" [srLabel]="'event.item.nameSr'" [itLabel]="'event.item.nameIt'"
                                  [siLabel]="'event.item.nameSlo'"/>
            </div>
          </div>
          <div class="col-12 col-xl-6 border-start border-md-start-0 ps-3 ps-xl-4">
            <app-date-time-from-to-input
              formControlName="leagueDates" [ranges]="{from: currentDate, to: undefined}"
              invalidMessageKey="app.common.error.range.current"
              [labelStart]="t('league.details.start.date')" [labelEnd]="t('league.details.end.date')"
            />
            <div class="row pt-3">
              <div class="col-xl-6">
                <!-- League status dropdown -->
                <app-select formControlName="status" [items]="statuses"
                            [valueKey]="'id'" [labelKey]="'id'" [labelKeyPrefix]="'event.item.status.'"
                            label="event.item.status"/>
              </div>
              <!-- League sport -->
              <div class="col-xl-6">
                <app-select formControlName="sportId" [items]="sports"
                            [valueKey]="'id'" [labelKey]="'id'" [labelKeyPrefix]="'app.common.sports.'"
                            label="league.details.sport"/>
              </div>
            </div>
            <div class="row pt-3">
              <div class="col-xl-6">
                <!-- Max number of events -->
                <app-input type="number" formControlName="maxNumberOfEvents" label="league.details.maxNumberOfEvents"
                           cssClass="flex-grow-1" [min]="1" [max]="1000"/>
              </div>

              <div class="col-xl-6">
                <app-multiselect-dropdown [options]="countriesOptions"
                                          formControlName="countries"
                                          [dropdownLabel]="t('app.common.country')"/>
              </div>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-12 col-xl-6 pt-xl-0 pt-3">
            <div class="field-title mt-3">
                  <span for="organiserDropdown"> {{ t('league.details.upload.league.photo') }}
                    @if (inputForm.controls['imageMedium'].errors?.['required']) {
                      <span>*</span>
                    }
                  </span>
              @if (inputForm.controls['imageMedium'].touched) {
                @for (errorMessage of inputForm.controls['imageMedium']!.errors | errorMessages:'imageMedium';track errorMessage) {
                  <span class="errorMes pt-1">{{ errorMessage }} </span>
                }
              }
            </div>
            <div class="mt-3">
              <app-drag-and-drop [selectedFile]="inputForm.value.imageMedium" (fileChange)="imageChange($event)"
                                 [useWithCropper]="true"/>
            </div>
          </div>
          <div class="col-12 col-xl-6 border-start border-md-start-0 ps-2 ps-xl-4 pt-xl-0 pt-3">
            <div class="field-title mt-3">
                  <span for="organiserDropdown"> {{ t('league.details.upload.league.logo') }}
                    @if (inputForm.controls['imageIcon'].errors?.['required']) {
                      <span>*</span>
                    }
                  </span>
              @if (inputForm.controls['imageIcon'].touched) {
                @for (errorMessage of inputForm.controls['imageIcon']!.errors | errorMessages:'imageIcon';track errorMessage) {
                  <span class="errorMes pt-1">{{ errorMessage }} </span>
                }
              }
            </div>
            <div class="mt-3">
              <app-drag-and-drop [selectedFile]="inputForm.value.imageIcon" (fileChange)="logoChange($event)"
                                 [useWithCropper]="true" [cropAreaWidth]="240" [cropAreaHeight]="240"/>
            </div>
          </div>
        </div>
      </app-admin-card-with-title>
      <!--    Description-->
      <app-admin-card-with-title
        [cardTitle]="t('league.details.description')" [showToggleButton]="true">
        <app-rich-text-editor-wrapper (contentChange)="onDescriptionChangeEvent($event)" [disabled]="disableEditing"
                              [content]="currentLeague?.description"/>
      </app-admin-card-with-title>
      <!--    Rules -->
      <app-admin-card-with-title
        [cardTitle]="t('league.details.rules')" [showToggleButton]="true">
        <app-rich-text-editor-wrapper (contentChange)="onRulesChangeEvent($event)" [disabled]="disableEditing"
                              [content]="currentLeague?.rules"/>
      </app-admin-card-with-title>
      <app-action-buttons-row (onSave)="onSave()"/>
    </div>
  </form>
</ng-container>
